import { forwardRef } from "react";

import Box from "@mui/material/Box";
import MaterialMenuItem from "@mui/material/MenuItem";

import { DashboardIcon } from "../Icon";

import { getMenuItemSx, menuItemContentSx } from "./styles";
import { MenuItemProps } from "./types";

import { mergeSx } from "@/common/helpers/mergeSx";

export const DashboardMenuItem = forwardRef<HTMLLIElement, MenuItemProps>(
  ({ children, color = "default", disabled = false, endIcon, startIcon, size = "small", sx, ...rest }, ref) => (
    <MaterialMenuItem
      {...rest}
      disabled={disabled}
      sx={mergeSx(getMenuItemSx(color, size), sx)}
      disableRipple
      ref={ref}
    >
      <Box component="span" sx={menuItemContentSx}>
        {startIcon && (
          <DashboardIcon vibe="inherit" size={size} sx={{ marginRight: 1 }}>
            {startIcon}
          </DashboardIcon>
        )}
        {children}
      </Box>
      {endIcon && (
        <DashboardIcon vibe="inherit" size={size} sx={{ marginLeft: 1 }}>
          {endIcon}
        </DashboardIcon>
      )}
    </MaterialMenuItem>
  )
);

DashboardMenuItem.displayName = "DashboardMenuItem";
